/** @jsxImportSource @emotion/react */

import { CircleHelp, Minus, Plus } from 'lucide-react';
import { useSelector } from 'react-redux';

import EmptyButton from 'ud-ui/components/empty-button';
import useZoom from 'ud-ui/components/fabric-canvas/hooks/use-zoom';
import { selectFabricManager } from '../../../../store/editor/selectors';
import useTipModal from '../../../hooks/modals/tip';
import { onHover, ZoomContainer } from './styles';

export function Zoom() {
  const manager = useSelector(selectFabricManager);
  const { increaseZoom, reduceZoom, zoom } = useZoom(manager);
  const { modal, open } = useTipModal();

  return (
    <ZoomContainer>
      <EmptyButton onClick={reduceZoom} icon={<Minus size={16} />} />
      {zoom}%
      <EmptyButton onClick={increaseZoom} icon={<Plus size={16} />} />
      <EmptyButton css={onHover} onClick={open} icon={<CircleHelp size={16} />} />
      {modal}
    </ZoomContainer>
  );
}
